export default {
  text: '#1f1f1f',
  primary: '#275584',
  secondary: '#2c67c0',
  background: '#ffffff',
  backgroundSecondary: '#4a4a4a',
  light: '#FFF',
  dark: '#202020'
}
